import * as React from "react";

function SvgComponent(props) {
  return (
    <svg 
      xmlns="http://www.w3.org/2000/svg" 
      width={28} 
      height={22} 
      viewBox="0 0 28 22" 
      {...props}
    >
      <path 
        data-name="Line 1" 
        fill="none" 
        stroke="currentColor" 
        strokeLinecap="round" 
        strokeWidth={2.5} 
        d="M1 1h26"
        style={{ transition: 'all 0.3s ease' }}
      />
      <path 
        data-name="Line 2" 
        fill="none" 
        stroke="currentColor" 
        strokeLinecap="round" 
        strokeWidth={2.5} 
        d="M1 11h26"
        style={{ transition: 'all 0.3s ease' }}
      />
      <path 
        data-name="Line 3" 
        fill="none" 
        stroke="currentColor" 
        strokeLinecap="round" 
        strokeWidth={2.5} 
        d="M1 21h26"
        style={{ transition: 'all 0.3s ease' }}
      />
    </svg>
  );
}

export default SvgComponent;
